import type { Asset2Tag } from '../graphql';

// POST to asset-manager /v2/assets returns a CreateAssetResponse, which contains a subset of the fields on an asset
export interface BaseCreateAssetResponseData {
  assetTagList?: Asset2Tag[];
  id: string;
  name: string;
  md5: string;
  review: string;
  'created-at': string;
  'updated-at': string;
  'file-size': number;
}

// Asset Manager Error Response
interface ErrorDetails {
  code: string;
  field: string | null;
  issue: string;
  location: string | null;
  value: string | null;
}

export interface CreateAssetErrorResponse {
  error?: {
    details?: ErrorDetails[];
    id: string;
    message: string;
    name: string;
    status: string;
  };
}

// Error types returned by uploadAsset
export enum AssetErrorType {
  cancel = 'cancel',
  api = 'API',
}

interface ClientError {
  type: AssetErrorType.cancel;
}

interface ApiError {
  type: AssetErrorType.api;
  apiStatusCode?: number;
  message?: string;
}

export type UploadError = ClientError | ApiError;

// POST to asset-manager /api/assets for assets 2 apis returns a CreateAsset2Response, which contains a subset of the fields on an asset
export interface BaseCreateAsset2ResponseData {
  id: string;
}

export interface CreateDisplayAsset2ResponseData extends BaseCreateAsset2ResponseData {
  'sub-class': 'DisplayAsset';
}

export interface CreateVideoAsset2ResponseData extends BaseCreateAsset2ResponseData {
  'sub-class': 'VideoAsset';
}

export type CreateAsset2ResponseData = CreateDisplayAsset2ResponseData | CreateVideoAsset2ResponseData;

export interface CreateAsset2SuccessResponse {
  data: CreateAsset2ResponseData;
}
